import React from 'react'
import Bnnerbg from "../../images/_Trazado_.png";
import Bnnercnt from "../../images/Group 6.png";
import { useLanguage } from '../../Providers/LanguageContext';


function Blogbanner() {
    const { language } = useLanguage()
    return (

        <div style={{
            cursor: 'default',
            background: 'linear-gradient(to bottom , #0c2637,#fff)'
        }}>




            <div id='blog-banner'  >
                <div className='container-fluid' style={{
                    display:'flex',
                    alignItems:'center',
                    paddingTop:'100px'
                }}>
                    <div className='col-xl-5 col-lg-5 col-md-12 col-12'>
                        <div className='banner-cnt'>
                            <img className="img-fluid" src={Bnnercnt} />
                        </div>
                    </div>

                    <div
                    //  id='banner-heading'
                     >
                        <div className='container'>
                            <div className='heading-name'>
                                <h2 style={{
                                    fontSize:'40px',
                                    fontWeight:'700',
                                    color:'#0c2637'
                                }}>{language.blog_get_view}</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>


    )
}

export default Blogbanner